import img_glasvordach_zugstaebe from './auswahl/glasvordach_zugstaebe.svg';

export const glasvordach_zugstaebe =
    {
        category: 'Glasvordach mit Zugstangen',
        product_img: img_glasvordach_zugstaebe,
        titel: 'Glasvordach mit Zugstangen',
        price: 338,
        wrapper: [{wrapper1: 0, wrapper2: 0, wrapper3: 0}],
        steps: [
            [[false], [false], [false]],
            {
                visited: [0],
                active_steps: []
            }
        ],
        dimensions: [
            {
                width: '',
                width_param: '90',
                height: '',
                height_param: '70 - 179'
          },
        ],
        glasart: '',
        pfosten: '',
        data_description: [
            {
                image: '',
                file: '',
                description: '',
                isUploadData: false
            }
        ],
        allVisitedSteps: false,
        is_merkliste: false
    }
